import { paper } from "../crm/ui";

/**
 * Design: components/crm/ui.tsx DataTable, sortRows and SectionCard.
 * A column is { id, label, render(row), sort?(row), default?, locked?, align?, width? }.
 */

// One table for the whole app: the design table lives in crm/ui.
export { DataTable } from "../crm/ui";

export function sortRows(rows, columns, sort) {
  if (!sort) return rows;
  const col = columns.find((c) => c.id === sort.id);
  if (!col?.sort) return rows;
  const f = col.sort;
  return [...rows].sort((a, b) => {
    const x = f(a);
    const y = f(b);
    return (x < y ? -1 : x > y ? 1 : 0) * sort.dir;
  });
}

export function SectionCard({ title, action, children, className = "" }) {
  return (
    <section aria-label={title} className={`${paper} flex flex-col gap-5 p-6 ${className}`}>
      <div className="flex min-h-9 items-center justify-between gap-4">
        <h2 className="text-h3 font-semibold">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
